import React from "react";
import { Container, ContentArea, PageTitle } from "./styles";
import Header from "../../components/Header";
import IconsBar from "../../components/IconsBar/IconsBar";
import { ConfigTabs } from "../../components/ConfigTabs/ConfigTabs";

const Configure = () => {
  return (
    <Container>
      <Header />
      <IconsBar />
      <ContentArea>
        <PageTitle>Configurações do Sistema</PageTitle>
        <ConfigTabs />
      </ContentArea>
    </Container>
  );
};

export default Configure;
